import { Button, Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import { RightContainer } from '../../components/RightContainer';
import WhiteInosio from '../../icons/whiteinosio.svg';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPasswordResetRequest, selectAuthState } from '../sagas/auth/authSlice';
import Link from '@mui/material/Link';
import BackIcon from '../../icons/backIcon.svg';
import { InputField } from '../../components/InputController';
const useStyles = makeStyles(() => ({
  rootContainer: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '24px',
  },
  rightContainer: {
    background: '#053742',
    width: '59%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    height: '100%',
  },
  leftContainer: {
    borderRadius: '24px 0px 0px 24px',
    background: '#ffffff',
    width: '42%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
  },
  mainTitle: {
    fontFamily: 'BMW Helvetica 75 !important',
    fontStyle: 'normal',
    fontSize: '24px !important',
    lineHeight: '30px !important',
    color: '#14142B',
    margin: '0 16px !important',
  },
  forgetpassBox: {
    width: '340px !important',
  },
  forgetpassText: {
    fontSize: '14px !important',
    textAlign: 'center',
  },
  sendReqText: {
    color: 'rgba(211, 211, 211, 1) !important',
    textDecoration: 'none !important',
    padding: ' 13px 0 0 10px',
    borderLeft: '3px solid rgba(211, 211, 211, 0.5)',
    height: '35px',
    cursor: 'pointer',
    zIndex: 30,
    fontSize: '14px !important',
    width: '27% !important',
  },

  ContinueBtn: {
    background: '#39A2DB !important',
    color: '#fff !important',
    width: '113px',
    height: '49px',
    borderRadius: '24px !important',
  },
  ContinueBtnMobile: {
    background: '#39A2DB !important',
    width: '100%',
    height: '49px',
    borderRadius: '24px !important',
    marginBottom: '13px !important',
    color: '#fff !important',
  },
  BtnContainer: {
    width: '340px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'space-between',
    justifyContent: 'space-between',
    marginTop: '20px',
    paddingBottom: '20px',
  },
  BtnContainerMobile: {
    display: 'flex',
    flexDirection: 'column-reverse',
    marginTop: '300px',
    paddingBottom: '20px',
  },
  logInBtn: {
    border: '1px solid #39A2DB !important',
    width: '90px',
    height: '49px',
    borderRadius: '24px !important',
  },
  logInBtnMobile: {
    border: '1px solid #39A2DB !important',
    width: '100%',
    height: '49px',
    borderRadius: '24px !important',
  },
  forgetText: {
    font: '14px Work Sans',
    lineHeight: '30px',
    color: '#39A2DB',
    textDecoration: 'none !important',
    maxHeight: '30px !important',
    margin: '10px !important',
    marginTop: '8px !important',
    marginBottom: '27px !important',
    paddingLeft: '5px !important',
    cursor: 'pointer',
    zIndex: 30,
  },
}));

export const ForgetPass = () => {
  const classes = useStyles();
  const matchesMobile = useMediaQuery('(max-width:600px)');
  const matches900 = useMediaQuery('(max-width:900px)');
  const matches1200 = useMediaQuery('(max-width:1200px)');
  const { isRequestPasswordResetSuccess, requestPasswordResetError } = useSelector(selectAuthState);
  const [email, setEmail] = useState('');
  const [step, setStep] = useState(0);
  const dispatch = useDispatch();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    dispatch({
      type: getPasswordResetRequest.type,
      payload: {
        email,
      },
    });
  };

  useEffect(() => {
    if (isRequestPasswordResetSuccess) setStep(1);
    else setStep(0);
  }, [isRequestPasswordResetSuccess]);

  return (
    <div className={classes.rootContainer}>
      {step === 1 ? (
        <Grid sx={{ flexDirection: 'column' }} className={classes.leftContainer}>
          <Box pb={6} sx={{ display: 'flex', alignItems: 'center' }}>
            <img src={WhiteInosio} style={{ width: '150px', height: '150px' }} alt="logo" />
          </Box>
          <Typography
            style={{
              fontWeight: 'bold',
              textAlign: 'center',
              fontSize: '18px',
              margin: '15px 0',
              width: '80vw',
            }}
          >
            Check your inbox!
          </Typography>
          <Box className={classes.forgetpassBox}>
            <Typography className={classes.forgetpassText}>
              If your email is linked to an account, we sent a password reset email to your inbox. It may take a few minutes to arrive. Be sure to check your spam folders.
            </Typography>
          </Box>
          <Box style={{ width: '340px', marginTop: '15px' }}>
            <Typography
              style={{
                textAlign: 'center',
                fontSize: '18px',
              }}
            >
              Email: {email}
            </Typography>
            <Box className={`${!matchesMobile ? classes.BtnContainer : classes.BtnContainerMobile}`}>
              <Button
                onClick={() => {
                  setStep(0);
                }}
                className={`${!matchesMobile ? classes.logInBtn : classes.logInBtnMobile}`}
                sx={{ marginRight: 5 }}
              >
                <img src={BackIcon} alt="" height="14px" style={{ marginRight: '5px' }} />
                back
              </Button>
              <Button href="/login" className={`${!matchesMobile ? classes.ContinueBtn : classes.ContinueBtnMobile}`}>
                Log In
              </Button>
            </Box>
            <Grid item sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Divider style={{ width: '100%' }} />
              <Grid item sx={{ display: 'flex', justifyContent: 'center' }}>
                <Link href="http://support.inosio.com/" className={classes.forgetText}>
                  Need Help ?
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      ) : (
        <Grid sx={{ flexDirection: 'column' }} className={classes.leftContainer}>
          <Box pb={6} sx={{ display: 'flex', alignItems: 'center' }}>
            <img src={WhiteInosio} style={{ width: '150px', height: '150px' }} alt="logo" />
          </Box>
          <Typography
            style={{
              fontWeight: 'bold',
              textAlign: 'center',
              fontSize: '18px',
              margin: '15px 0',
              width: '80vw',
            }}
          >
            Please enter your registered email address to reset your password
          </Typography>
          {requestPasswordResetError?.message && (
            <Typography
              style={{
                fontFamily: 'BMWHelvetica',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '18px',
                color: '#DB3939',
              }}
              data-e2e="globalError"
            >
              {' '}
              {requestPasswordResetError?.message}
            </Typography>
          )}
          <Box style={{ width: '340px', marginTop: '15px' }} component="form" onSubmit={handleSubmit}>
            <InputField name={'email'} placeholder={'Email'} label={'Email'} value={email} isError={false} onChange={(e) => setEmail(e.target.value)} />
            <Box className={`${!matchesMobile ? classes.BtnContainer : classes.BtnContainerMobile}`}>
              <Button href="/login" className={`${!matchesMobile ? classes.logInBtn : classes.logInBtnMobile}`}>
                Log In
              </Button>
              <Button type="submit" className={`${!matchesMobile ? classes.ContinueBtn : classes.ContinueBtnMobile}`}>
                Continue
              </Button>
            </Box>
            <Grid item sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Divider style={{ width: '100%' }} />
              <Grid item sx={{ display: 'flex', justifyContent: 'center' }}>
                <Link href="http://support.inosio.com/" className={classes.forgetText}>
                  Need Help ?
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      )}
      {!(matches900 && matches1200) ? (
        <Grid className={classes.rightContainer}>
          <RightContainer />
        </Grid>
      ) : (
        <></>
      )}
    </div>
  );
};
